import React from 'react';
export function AlertBanner() {
  return <div className="bg-brand-primary text-white py-2 px-4 text-center" data-id="element-16">
      <p className="text-xs sm:text-sm font-bold uppercase tracking-wider" data-id="element-17">
        ATTENZIONE: DONNE ITALIANE STANCHE DI COMBATTERE CONTRO UN METABOLISMO
        BLOCCATO
      </p>
    </div>;
}